<div class="data-filter" style="padding: 0px 5px;">
    <label style="margin: 0px; font-weight: bold;">{{label}}</label>
    <ng-select class="custom" [items]="options" bindValue="value" bindLabel="label"
        [(ngModel)]="model" (change)="change()"></ng-select>
</div>